module.exports = __webpack_public_path__ + "static/img/s33.fb14c23.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/demoimages/s33.png
// module id = hqJs
// module chunks = 0